import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Props } from './types';

export const Error: FC<Props> = ({ className, error }) => {
  const router = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const { message, stack } = error;

  return (
    <div
      className={`flex flex-col items-center justify-center min-h-screen p-4 bg-background ${className}`}
    >
      <div className="flex flex-col items-center p-6 bg-card shadow-lg rounded-lg max-w-md w-full">
        <h2 className="text-xl font-semibold mb-2 text-foreground">Что-то пошло не так</h2>
        <p className="text-center text-muted-foreground mb-4">
          Возникла проблема с обработкой запроса. Попробуйте обновить страницу или вернитесь на
          предыдущую.
        </p>
        <button
          onClick={() => router(-1)}
          className="px-4 py-2 border border-destructive text-destructive rounded hover:bg-destructive/10 transition-colors mb-4"
        >
          Вернуться назад
        </button>

        <div className="w-full">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full text-left p-2 bg-muted hover:bg-accent rounded text-sm text-foreground flex justify-between items-center"
          >
            <span>Детали ошибки</span>
            <span>{isExpanded ? '▲' : '▼'}</span>
          </button>
          {isExpanded && (
            <div className="mt-2 p-3 bg-muted rounded text-xs font-mono whitespace-pre-wrap overflow-auto max-h-60">
              {stack || message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
